import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'Jobs', pathMatch: 'full' },
  { path: '', data: { preload: false }, loadChildren: () => import('./home/home.module').then(m => m.HomeModule)},
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
